<template>
  <div :class="['message-container', `type-${type}`]">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

type TMessageType =
  | 'default'
  | 'white'
  | 'subtext'
  | 'disabled'
  | 'info'
  | 'primary'
  | 'link'
  | 'success'
  | 'danger'
  | 'warning'

export default defineComponent({
  props: {
    type: {
      type: String as PropType<TMessageType>,
      default: 'default'
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.message-container {
  padding: $spacing-unit $spacing-unit * 2;
  font-size: $font-size;
  line-height: 20px;
  border-style: solid;
  border-width: 1px;
  border-radius: $round;
  box-shadow: 0 0 2px 0 $shadow-color;

  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
}

.type {
  &-default {
    color: $text-color;
    border-color: $text-color;
  }

  &-white {
    color: $text-color-white;
    border-color: $text-color-white;
  }

  &-subtext {
    color: $sub-text-color;
    border-color: $sub-text-color;
  }

  &-disabled {
    color: $disabled-color;
    border-color: $disabled-color;
  }

  &-info {
    color: $info-color;
    border-color: $info-color;
  }

  &-primary {
    color: $primary-color;
    border-color: $primary-color;
  }

  &-link {
    color: $link-color;
    border-color: $link-color;
  }

  &-success {
    color: $success-color;
    border-color: $success-color;
  }

  &-danger {
    color: $danger-color;
    border-color: $danger-color;
  }

  &-warning {
    color: $warning-color;
    border-color: $warning-color;
  }
}
</style>
